/**
 * Created by lhzbxx on 2016/11/7.
 *
 * mutations.js
 */

import orderApi from '../../api/order'
import Vue from 'vue'

import * as types from '../mutation-types'


const state = {
  info: {
    total: 0,
    page: 0
  },
  savedItems: [],
  checkout: [],
  order: null,
  unpaidCount: 0,
  unReviewedCount: 0,
}

const mutations = {
  [types.RECEIVE_ORDER] (state, orders) {
    state.info.total = orders.totalElements
    state.info.page = orders.totalPages
    window.localStorage.setItem('orderInfo', JSON.stringify(state.info))
  },
  [types.ADD_TO_ORDER] (state) {
    state.info.total += 1
    window.localStorage.setItem('orderInfo', JSON.stringify(state.info))
  },
  [types.REMOVE_ORDER] (state) {
    state.info.total -= 1
    window.localStorage.setItem('orderInfo', JSON.stringify(state.info))
  },
  [types.CHECKOUT] (state, carts) {
    state.checkout = carts
    window.localStorage.setItem('checkout', JSON.stringify(state.checkout))
  },
  [types.ORDER] (state, order) {
    state.order = order
  },
  [types.GET_DATA_FROM_STORAGE] (state) {
    console.log('orders:GET_DATA_FROM_STORAGE')
    state.checkout = JSON.parse(window.localStorage.getItem('checkout'))
    state.info = JSON.parse(window.localStorage.getItem('orderInfo'))
    if (state.info === null) {
      state.info = {
        total: 0,
        page: 0
      }
    }
  },
  [types.SET_UNPAID_COUNT](state, count = 0){
    state.unpaidCount = count
  },
  [types.SET_UN_REVIEWED_COUNT](state, count = 0){
    state.unpaidCount = count
  }
}
const actions = {
  async fetchUnpaidCount ({commit}) {
    try {
      let unpaidCount = await orderApi.countUnpaid()
      commit(types.SET_UNPAID_COUNT, unpaidCount)
      return false
    }
    catch (error) {
      console.log(error)
    }
  },
  async fetchUnReviewedCount ({commit}) {
    try {
      let unpaidCount = await orderApi.countUnReviewed()
      commit(types.SET_UN_REVIEWED_COUNT, unpaidCount)
      return false
    }
    catch (error) {
      // Vue.tipError(error)
      console.log(error)
    }
  },
}

export default{
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/module/orders.js